import { render, staticRenderFns } from "./plmtech-firstcar-list.vue?vue&type=template&id=2c5e0696&scoped=true"
import script from "./plmtech-firstcar-list.vue?vue&type=script&lang=js"
export * from "./plmtech-firstcar-list.vue?vue&type=script&lang=js"
import style0 from "./plmtech-firstcar-list.vue?vue&type=style&index=0&id=2c5e0696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e0696",
  null
  
)

export default component.exports